export default __webpack_public_path__ + "static/muscle_small-83ecba9b75adffbcfe727d4c7811d7f2.png";